/* tslint:disable */

declare var Object: any;
export interface StockAuditRecordInterface {
  "reference": string;
  "items"?: Array<any>;
  "createdBy"?: any;
  "remarks"?: string;
  "createdAt": Date;
  "id"?: number;
}

export class StockAuditRecord implements StockAuditRecordInterface {
  "reference": string;
  "items": Array<any>;
  "createdBy": any;
  "remarks": string;
  "createdAt": Date;
  "id": number;
  constructor(data?: StockAuditRecordInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockAuditRecord`.
   */
  public static getModelName() {
    return "StockAuditRecord";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockAuditRecord for dynamic purposes.
  **/
  public static factory(data: StockAuditRecordInterface): StockAuditRecord{
    return new StockAuditRecord(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockAuditRecord',
      plural: 'stockAuditRecords',
      path: 'stockAuditRecords',
      idName: 'id',
      properties: {
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "items": {
          name: 'items',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "createdBy": {
          name: 'createdBy',
          type: 'any'
        },
        "remarks": {
          name: 'remarks',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
